import { useTranslation } from 'react-i18next'
import { Alert, Box, Button, Grid, Paper, Typography, useTheme } from '@mui/material'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { useGetRedirectURI } from '../hooks/useGetRedirectURI'
import { useGetAzureRedirectURI } from '../hooks/useGetAzureRedirectURI'
import splashArt from 'assets/svg/splash-art.svg'
import LKQLogo from 'assets/svg/LKQLogoWhite.svg'
import LKQBackground from 'assets/svg/lkq-background.svg'

export function Home() {
  const { t } = useTranslation()
  const theme = useTheme()
  const { data: redirectURI } = useGetRedirectURI()
  const { data: azureRedirectURI } = useGetAzureRedirectURI()

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        backgroundImage: `url(${LKQBackground})`,
        backgroundSize: 'auto, 100%',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: { lg: '50vw', xl: '40vw' },
          mx: 'auto'
        }}
      >
        <Paper sx={{ overflow: 'hidden', width: '100%' }}>
          <Grid container>
            <Grid item xs={6}>
              <Box
                sx={{
                  backgroundColor: 'rgba(0, 85, 150,0.3)',
                  pt: 5,
                  display: 'flex',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  height: '100%',
                  position: 'relative'
                }}
              >
                <Box
                  sx={{
                    display: 'block',
                    width: '8em',
                    height: '3em',
                    backgroundColor: 'primary.main',
                    mask: `url(${LKQLogo}) no-repeat center`,
                    position: 'absolute',
                    top: theme.spacing(3.5),
                    left: theme.spacing(3)
                  }}
                />
                <Box component='img' alt='splash-art' src={splashArt} sx={{ flex: '1 0 140%' }} />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', p: 3, height: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  <Typography variant='h4'>{t('Auth.WelcomeTitleSupport')}</Typography>
                  {!redirectURI && !azureRedirectURI && (
                    <Alert severity='error' sx={{ mt: 2 }}>
                      {t('Auth.Error_AuthProvider')}
                    </Alert>
                  )}
                  {(redirectURI || azureRedirectURI) && (
                    <Typography variant='body1' sx={{ my: 3, textAlign: 'center' }}>
                      {t('Auth.WelcomeSubtitleSupport')}
                    </Typography>
                  )}
                  {/* <Box sx={{ paddingX: { xs: 3, sm: 5, lg: 3, xl: 4 } }}> */}
                  {redirectURI && (
                    <Button
                      startIcon={<LockOpenIcon />}
                      size='large'
                      variant='contained'
                      href={redirectURI}
                      data-testid='support-login-button'
                      sx={{ minWidth: '220px', mb: 2 }}
                    >
                      {t('Auth.BtnLoginOkta')}
                    </Button>
                  )}
                  {azureRedirectURI && (
                    <Button
                      startIcon={<LockOpenIcon />}
                      size='large'
                      variant='contained'
                      href={azureRedirectURI}
                      data-testid='support-azure-login-button'
                      sx={{ minWidth: '220px' }}
                    >
                      {t('Auth.BtnLoginAzure')}
                    </Button>
                  )}
                  {/* </Box> */}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  )
}

export default Home
